import React, { useState, useEffect } from "react";
import { Typography, Grid, Button, Box, Container } from "@mui/material";
import { ArrowRight, ArrowLeft } from '@mui/icons-material';

import AccumulationChart from "./acumulation-chart";
import DistributionChart from "./distribution-chart";
import VolatilityChart from "./volatility-chart";
import PresentationLayout from "./layout";
import { useHistory } from "react-router-dom";


const ACCUMULATION_CHART = 0;
const DISTRIBUTION_CHART = 1;
const VOLATILITY_BUFFER_CHART = 2;

const PresentationResults = (props) => {
    const [presentationPage, setPresentationPage] = useState(0);
    const history = useHistory()

    const getPage = () => {
        switch (presentationPage) {
            case ACCUMULATION_CHART:
                return <AccumulationChart />;
            case DISTRIBUTION_CHART:
                return <DistributionChart />;
            case VOLATILITY_BUFFER_CHART:
                return <VolatilityChart />;
        }
    };

    return (
        <PresentationLayout
            page={presentationPage}
            setPage={(index) => {
                setPresentationPage(index);
            }}
            setPresentationPage={setPresentationPage}
            presentationPage={presentationPage}
        >
            {<></>}
            {(
                <Grid container style={{ height: '61vh' }}>
                    {getPage()}
                    <Grid item xs={12} className={"plan-inputs-footer full-width"}>
                        <Grid container spacing={3}>
                            <Grid item xs={6} className={"left-button"}>
                                <Button onClick={props.prev}><ArrowLeft />Back</Button>
                            </Grid>
                            <Grid item xs={6} className={"right-button"}>
                                <Button onClick={() => history.push("/plan-output")}>Continue<ArrowRight /></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </PresentationLayout>
    );
};

export default PresentationResults;
